const updates = [
  {
    date: '2026.07.31',
    title: '《庆余年3》全集上线红桃视频频道',
    desc: '张若昀领衔主演，第三季终章今日完整上线，玫瑰视频已同步全部剧集资源',
  },
  {
    date: '2026.07.30',
    title: '樱桃视频频道新增4K修复专区',
    desc: '收录超过200部经典港片4K修复版本，画质大幅提升，怀旧观影体验全面升级',
  },
  {
    date: '2026.07.29',
    title: '糖心视频国创动画频道改版',
    desc: '全新UI界面和智能推荐算法上线，发现优质国漫更方便，支持弹幕互动功能',
  },
  {
    date: '2026.07.28',
    title: '茄子视频悬疑剧场月度片单更新',
    desc: '本月新增12部高分悬疑剧集和8部推理电影，包括多部豆瓣9分以上口碑佳作',
  },
  {
    date: '2026.07.27',
    title: '玫瑰视频新增线路智能切换功能',
    desc: '播放过程中自动检测最优线路，遇卡顿秒级切换，大幅提升观影流畅度',
  },
  {
    date: '2026.07.26',
    title: '暑期档特别策划"追剧马拉松"上线',
    desc: '精选10部高分剧集打包推荐，涵盖古装、悬疑、科幻、甜宠四大类型，一次看个够',
  },
  {
    date: '2026.07.25',
    title: '手机端体验全面优化升级',
    desc: '适配最新iOS和Android系统，提升页面加载速度40%，降低流量消耗30%',
  },
  {
    date: '2026.07.24',
    title: '红桃视频多部新剧预告片上线',
    desc: '《狐妖小红娘》《大奉打更人》《玫瑰故事》等暑期档新剧预告抢先看',
  },
  {
    date: '2026.07.23',
    title: '用户反馈系统全面升级',
    desc: '新增内容求片功能和问题追踪系统，提交需求后24小时内响应处理',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center">
          最新动态
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          跟紧玫瑰视频每一步成长，不错过每一次精彩升级
        </p>

        <div className="mt-8 md:mt-10 max-w-3xl mx-auto">
          <div className="relative pl-6 md:pl-8 border-l-2 border-primary-200">
            {updates.map((update, i) => (
              <div
                key={i}
                className={`relative pb-8 md:pb-10 ${i === updates.length - 1 ? 'pb-0' : ''}`}
              >
                <span className="absolute -left-[11px] md:-left-[13px] top-0 w-5 h-5 rounded-full bg-primary-500 border-3 border-background-100 flex-shrink-0"></span>
                <span className="text-xs text-foreground-400 font-medium">{update.date}</span>
                <h3 className="mt-1 text-sm md:text-base font-heading font-semibold text-foreground-900">
                  {update.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {update.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}